<template>
  <!-- Avertissement seulement : l'accueil choisit d'ouvrir le dossier existant ou de continuer -->
  <div v-if="doublons.length" class="alert alert-warning py-2 mb-0">
    <div class="fw-semibold mb-1"><i class="bi bi-exclamation-triangle me-1"></i>Ce patient existe peut-être déjà :</div>
    <ul class="mb-1 small ps-3">
      <li v-for="d in doublons" :key="d.id">
        <router-link :to="{ name: 'information_personnelle', params: { id: d.id } }" target="_blank">{{ d.nomComplet }}</router-link>
        · {{ d.numeroDossier }}<span v-if="d.ageAffiche"> · {{ d.ageAffiche }}</span><span v-if="d.telephone"> · {{ d.telephone }}</span>
        <span class="text-muted"> ({{ d.raison }})</span>
      </li>
    </ul>
    <small class="text-muted">Vérifiez avant d'enregistrer. Vous pouvez continuer s'il s'agit d'une autre personne.</small>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'AlerteDoublons',
  props: {
    nom: { type: String, default: '' },
    prenom: { type: String, default: '' },
    dateNaissance: { type: String, default: '' },
    exclure: { type: [Number, String], default: null },
  },
  data() {
    return { doublons: [], minuterie: null }
  },
  watch: {
    nom: 'planifier',
    prenom: 'planifier',
    dateNaissance: 'planifier',
  },
  methods: {
    planifier() {
      clearTimeout(this.minuterie)
      this.minuterie = setTimeout(this.verifier, 500)
    },
    async verifier() {
      if ((this.nom || '').trim().length < 2 || (!(this.prenom || '').trim() && !this.dateNaissance)) {
        this.doublons = []
        return
      }
      try {
        const r = await api.getItems('patients/doublons', {
          nom: this.nom.trim(), prenom: (this.prenom || '').trim(), dateNaissance: this.dateNaissance || undefined, exclure: this.exclure || undefined,
        })
        this.doublons = r.data.data || []
      } catch (e) {
        this.doublons = []
      }
    },
  },
  beforeUnmount() {
    clearTimeout(this.minuterie)
  },
}
</script>
